Bundle = {
    Defaults: {
        // Convenience functions to reference various important divs within the build.
        // If you structure your HTML differently than our example build, you can alter these
        // functions to reference the correct divs.
        getBundleDiv: function() {
            return $(".bundle");
        },
        getBundleGridDiv: function() {
            return Bundle.Defaults.getBundleDiv().find(".bundle-grid");
        },
        getBundleDetailsDiv: function() {
            return Bundle.Defaults.getBundleDiv().find(".bundle-details");
        },
        getAddToCartDiv: function() {
            return $("#bundle-add-to-cart");
        },
        getPlanPicker: function() {
            return document.querySelector('skio-plan-picker');
        },
        getProduct: function() {
            const skioPlanPicker = Bundle.Defaults.getPlanPicker();
            if(skioPlanPicker) {
                return skioPlanPicker.product;
            }

            return null;
        },
    },
    Utils: {
        // Utility functions used throughout the rest of the build
        generateGuid: function() {
            // Generates a unique guid to be used for the bundle_id
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                /[xy]/g,
                function(c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                }
            );
        },
        calculateBundleQuantity: function($bundle) {
            // Calculates the total number of items selected on the page.
            // Will loop through all grid items and sum up the total bundle
            // quantity based on the data-qty attribute of each variant.
            // 1.) $bundle = top level bundle div of the grid matrix
            var bundle_qty = 0;
            $bundle.find(".bundle-item").each(function() {
                bundle_qty += Number($(this).attr("data-qty"));
            });
            return bundle_qty;
        },
        calculateBundleQuantityPerCategory: function($bundle) {
            var bundleCategories = [];
            var category = "";
            $bundle.find(".bundle-item").each(function() { 
                category = $(this).attr("data-category");
                bundleCategories[category] = 0;
            })

            $bundle.find(".bundle-item").each(function() { 
                category = $(this).attr("data-category");
                bundleCategories[category] += Number($(this).attr("data-qty"));
            })

            return bundleCategories;
        },
        isSubscription: function(product) {
            // Determines whether the user has selected the One-time purchase
            // or Subscribe and Save option on the Skio widget
            const skioPlanPicker = Bundle.Defaults.getPlanPicker();
            return skioPlanPicker?.selectedSellingPlan ? true : false;
        },
        updateBundleQuantity: function($item, increment, thisElement) {
            // Main function to handle quantity manipulation. Pass in the grid
            // item along with the quantity to increment or decrement. Then it will
            // determine the current and new item/bundle quantities. Then it checks
            // constraints, and if valid, update all necessary data attributes,
            // interface output, and enable/disable any buttons.
            // 1.) $item = the clicked plus or minus .bundle-item parent div
            // 2.) increment = the amount to increase or decrease the quantity
            // Get bundle parent reference and min/max numbers
            var $bundle = $item.closest(".bundle-grid");
            var bundle_min = Number($bundle.attr("data-bundle-min"));
            var bundle_max = Number($bundle.attr("data-bundle-max"));
            var bundle_minimun = Number($bundle.attr("data-bundle-minimun"));
            // Calculate current item and bundle quantity
            var bundle_qty = Bundle.Utils.calculateBundleQuantity($bundle);
            var item_qty = Number($item.attr("data-qty"));
            // Calculate the new bundle and item quantities with the increment added
            var new_bundle_qty = bundle_qty + increment;
            var real_bundle_qty = new_bundle_qty;
            var category = $item.attr("data-category");
            if (new_bundle_qty !== bundle_max) {
                // real_bundle_qty = new_bundle_qty - all_box_added;
                real_bundle_qty = new_bundle_qty;
            }
            // $bundle.find(".bundle-item").each(function() {
            //     if ($(this).attr("data-category") == 'box') {
            //         real_bundle_qty = real_bundle_qty - 1;
            //     } else {
            //         real_bundle_qty = real_bundle_qty + 1;
            //     }
            // });
            // console.log('bundle_qty', bundle_qty)

            // console.log('new_bundle_qty', new_bundle_qty)
            // console.log('all_box_added', all_box_added)
            // console.log('real_bundle_qty', real_bundle_qty)
            if (new_bundle_qty < 0) {
                new_bundle_qty = 0
            }
            var new_item_qty = item_qty + increment;

            // Check constraints to make sure we can perform the action
            if (
                Bundle.Constraints.isItemGreaterThanZero(new_item_qty) &&
                Bundle.Constraints.isBundleGreaterThanMin(new_bundle_qty, bundle_min) &&
                Bundle.Constraints.isBundleLessThanMax(new_bundle_qty, bundle_max)
            ) {
                //Update quantities and price
                $item.attr("data-qty", new_item_qty);
                $item.find(".quantity").val(new_item_qty);
                $(".bundle-details .current-qty").html(new_bundle_qty);
                Bundle.Utils.updatePrice();
                // Toggle the Add to Cart Button if max items is reached
                if (real_bundle_qty >= bundle_minimun) {
                    Bundle.Defaults.getAddToCartDiv().prop("disabled", false);
                } else {
                    Bundle.Defaults.getAddToCartDiv().prop("disabled", true);
                }

                //Update plus/minus button's disabled property
                $bundle.find(".bundle-item").each(function() {
                    var item_qty = $(this).attr("data-qty");

                    var is_disabled = Bundle.Constraints.isBundleEqualParam(new_bundle_qty, bundle_max) ?
                        true :
                        false;
                    $(this).find(".plus.btn-qty").prop("disabled", is_disabled);

                    var is_disabled =
                        Bundle.Constraints.isBundleEqualParam(new_bundle_qty, bundle_min) ||
                        Bundle.Constraints.isBundleEqualParam(item_qty, 0) ?
                        true :
                        false;
                    $(this).find(".minus.btn-qty").prop("disabled", is_disabled);
                });
            }
            
            if (bundle_qty < new_bundle_qty) {
                if(thisElement.data('category') === 'box') {
                  $('.product-bundle-added--box.--placeholder').remove();
                } else {
                  $('.product-bundle-added.--placeholder')[0].remove()
                }
                $(".js-product-bundles").append(`
                    <div class="product-bundle-added product-bundle-item-${thisElement.data('category')} product-added-${thisElement.data("variant-id")}">
                    <div class="product-bundle-added-image">
                        <div class="product-bundle-added-image-placeholder" style="background-image: url('${thisElement.data("variant-image")}');"></div>
                    </div>
                    <h5 class="product-bundle-added-title">
                        ${thisElement.data("variant-name")}
                    </h5>
                    <div class="product-bundle-added-remove product-bundle-added-remove--${$item.attr("data-category")} js-remove" data-variant-id="${thisElement.data("variant-id")}" data-element=".product-added-${thisElement.data("variant-id")}">
                        <button type="button"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close fal fa-times" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M19 17.61l27.12 27.13m0-27.13L19 44.74"/></svg></button>
                    </div>
                    </div>
                `);
            } else {
                if($(".product-bundle-added--box").length > 0) {
                    $(`
                    <div class="product-bundle-added --placeholder">
                        <div class="product-bundle-added-image">
                        <div class="product-bundle-added-image-placeholder"></div>
                        </div>
                        <h5 class="product-bundle-added-title">
                        (Add an item)
                        </h5>
                    </div>
                    `).insertBefore(".product-bundle-added--box");
                } else {
                    console.log('product removed, adding placeholder')
                    if(category == "box") {
                        console.log('placeholder box')
                        $(".js-product-bundles").append(`<div class="product-bundle-added product-bundle-added--box --placeholder">
                        <div class="product-bundle-added-image">
                          <div class="product-box-bundle-added-image-placeholder"></div>
                        </div>
                        <h5 class="product-bundle-added-title">
                          (Add a box)
                        </h5>
                      </div>`);
                    } else {
                        $(".js-product-bundles").append(`
                        <div class="product-bundle-added --placeholder">
                            <div class="product-bundle-added-image">
                            <div class="product-bundle-added-image-placeholder"></div>
                            </div>
                            <h5 class="product-bundle-added-title">
                            (Add an item)
                            </h5>
                        </div>
                        `);
                    }
                }
                
            }
        },
        updatePrice: function() {
            // Main function to update price div within the .bundle-details class div.
            // Function will loop through all grid items and grab their qty and variant_id.
            // Then it uses the ReCharge object to determine the correct price based on
            // which purchase type the user has selected (One-time purchase or Subscribe & Save).
            // Based on purchase type, function will multiple the appropriate price by quantity
            // and sum all prices together to generate a total price. This price is then
            // output to the .bundle-price div.
            // Get bundle parent and product references
            var $bundle = Bundle.Defaults.getBundleGridDiv();
            var product = Bundle.Defaults.getProduct();
            // Determine whether the user has the One-time purchase or
            // Subscribe & Save purchase type option selected
            var is_subscription = Bundle.Utils.isSubscription(product);
            var price = 0;
            // Loop through all product grid items
            $bundle.find(".bundle-item").each(function() {
                // If grid item's quantity is above 0, use ReCharge
                // object to determine price and multiple by quantity
                var qty = Number($(this).attr("data-qty"));
                if (qty > 0) {
                    const skioPlanPicker = Bundle.Defaults.getPlanPicker();
                    var variant_id = $(this).attr("data-variant-id");
                    var variant_price = skioPlanPicker.getVariantPrice(variant_id, false);
                    price += qty * (Number(variant_price) / 100);
                }
            });
            // Format price into currency and output to .bundle-price div
            var $details = Bundle.Defaults.getBundleDetailsDiv();
            var formatted_price = price.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
            });
            $details.find(".bundle-price").html(formatted_price);
        },
    },
    Constraints: {
        // Requirement functions to determine whether the user is
        // performing an action that is forbidden
        isItemGreaterThanZero: function(qty) {
            // Check that the item quantity doesn't fall below zero
            // 1.) qty = item quantity of the variant
            if (qty < 0) {
                console.log("Item quantity cannot be less than 0.");
                return false;
            }
            return true;
        },
        isBundleGreaterThanMin: function(qty, min) {
            // Check that the bundle quantity doesn't fall below the minimum quantity
            // 1.) qty = total bundle quantity of the page
            // 2.) min = minimum value the bundle quantity can't fall below
            if (qty < min) {
                console.log("Quantity cannot be less than the minimum.");
                return false;
            }
            return true;
        },
        isBundleLessThanMax: function(qty, max) {
            // Check that the bundle quantity doesn't go above the maximum quantity
            // 1.) qty = total bundle quantity of the page
            // 2.) max = maximum value the bundle quantity can't rise above
            if (qty > max) {
                console.log("Quantity cannot be greater than maximum.");
                return false;
            }
            return true;
        },
        isBundleEqualMax: function(qty, max) {
            // Check that the bundle quantity is equal to the maximum quantity
            // 1.) qty = total bundle quantity of the page
            // 2.) max = maximum value the bundle quantity can't rise above
            return qty == max ? true : false;
        },
        isBundleEqualParam: function(qty, param) {
            // Check that the bundle quantity is equal to param
            // 1.) qty = total bundle quantity of the page
            // 2.) param = value to compare qty against
            return qty == param ? true : false;
        },
        isBundleName: function(name, current_name) {
            // Check that the bundle name is equal to the current bundle name
            // 1.) name = name of the bundle
            // 2.) current_name = name of the current bundle
            return name.toLowerCase() === current_name.toLowerCase() ? true : false;
        },   
        isBoxIncluded: function($bundle, new_item_qty, category ) {
            // Check if item in bundle can be added, taking into consideration the box 
            // and all other items in bundle
            var categories = Bundle.Utils.calculateBundleQuantityPerCategory($bundle);
            var bundle_max_without_box = Number($bundle.attr("data-bundle-max")) - 1;
            categories[category] += new_item_qty;
            var totalItems = 0;

            for(category in categories) {
                if(category != 'box') {
                    totalItems += categories[category];
                }
            }

            if(totalItems > bundle_max_without_box) {
                console.log("Quantity cannot be greater than maximum.");
                return false;
            } else {
                return true;
            } 
        },
        isBoxOptional: function(bundleData) {
            // Check if box is optional
            return bundleData.box_optional;
        }
    },
    Cart: {
        // Functions used when adding the bundle to the cart
        processAddToCart: function(bundleData) {
            // Top level function tied to the Add to Cart button.
            // Function will check constraints to make sure we can
            // add the bundle to the cart, then it will generate
            // the cart array and make the AJAX call to Shopify's API.
            // Once added to cart, we redirect to the /cart page.
            // Get bundle parent, bundle max value, and total bundle quantity values
            var $bundle = Bundle.Defaults.getBundleGridDiv();
            var qty = Bundle.Utils.calculateBundleQuantity($bundle);
            var bundle_max = Number($bundle.attr("data-bundle-max"));
            var bundle_min = Number($bundle.attr("data-bundle-minimun"));

            // Ensure we can process the cart, and if not, break out of function
            if (Bundle.Constraints.isBoxOptional(bundleData)) {
                if( !Bundle.Constraints.isBundleGreaterThanMin(qty, bundle_min) ) {
                    console.log("Cannot process Add to Cart. Qty does not equal min or max total.");
                    return;
                }
            } else if (!Bundle.Constraints.isBundleEqualMax(qty, bundle_max)) {
                console.log(
                    "Cannot process Add to Cart. Qty does not equal max total."
                );
                return;
            }
            //Generate the product array to pass to AJAX call
            var product = Bundle.Defaults.getProduct();
            var items = Bundle.Cart.generateCart($bundle, product);
            // Ensure there are items to add to cart, and if so, make
            // API call and redirect to /cart page
            console.log('PROCESS ADD TO CART')

            if (items.length > 0) {
                Bundle.Cart.processToCart(items);
            } else {
                console.log("No items available to add to cart.");
            }
        },
        generateCart: function($bundle, product) {
            // Check that the bundle quantity is equal to param
            // 1.) $bundle = top level bundle div of the grid matrix
            // 2.) product = the ReCharge product object tied to the page
            var cart = [];
            var is_subscription = Bundle.Utils.isSubscription(product);
            // bundle_id that we will pass to each product object as a
            // line item property to associate them to this bundle
            var bundle_id = Bundle.Utils.generateGuid();
            // Determine whether the user has the One-time purchase or
            // Subscribe & Save purchase type option selected. If Subscribe
            // & Save, generate the shipping interval unit_type and frequency
            // that are passed through on ReCharge orders.
            // Loop through each product grid item

            const skioPlanPicker = Bundle.Defaults.getPlanPicker();
            const sellingPlan = skioPlanPicker?.selectedSellingPlan;
            $bundle.find(".bundle-item").each(function() {
                // If item's quantity is greater than 0, add
                // to the cart array
                var qty = $(this).attr("data-qty");
                if (Number(qty) > 0) {
                    var variant_id = $(this).attr("data-variant-id");
                    // Pass the variant_id, quantity, and bundle_id
                    // for each grid item we process
                    var item = {
                        id: variant_id,
                        quantity: qty,
                        ...(sellingPlan && {
                            selling_plan: sellingPlan.id,
                        }),
                        properties: {
                            bundle_id: bundle_id,
                        }
                    };
                    cart.push(item);
                }
            });
            return cart;
        },
        processToCart: function(items) {
            // Makes API call to add bundle items to cart. If the
            // call is successful, redirect to /cart page. If error,
            // display the error to the console.
            // 1.) items = the product array to be passed to the Shopify
            // API. Bundle.Cart.generateCart() function builds this array.
            // console.log(items);
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: items,
                },
                dataType: "json",
                success: function() {
                    window.location.href = "/cart";
                },
                error: function(jqXHR, text_status, error_thrown) {
                    console.log(text_status, error_thrown);
                },
            });
        },
    },
    init: function() {
        var productsJSON;
        if (document.querySelector('#bundles-json')) {
            products = $('#bundles-json')
            .find('script[type="application/json"]')
            .first()
            productsJSON = JSON.parse(products.text())
        }
                
        // var box_added = false;
        // Initialization function to register all click handlers
        // Registers each grid item's minus button
        $("body").on("click", ".bundle .minus", function() {
            if (parseFloat($(document).find('.js-qty__num[data-variant-id="' + $(this).data("variant-id") + '"]').val()) !== 0) {
                // if ($(this).data('category').includes('box')) {
                //     all_box_added = all_box_added - 1;
                //     box_added = false;
                // }
                var item = $(this).closest(".bundle-item");
                Bundle.Utils.updateBundleQuantity(item, -1, $(document).find('.minus[data-variant-id="' + $(this).data("variant-id") + '"]'));
                $(document).find(".product-added-" + $(this).data("variant-id"))[0].remove();
            }
        });
        
        // Registers each grid item's plus button
        $("body").on("click", ".bundle .plus", function() {
            var item = $(this).closest(".bundle-item");
            var $bundle = item.closest(".bundle-grid");
            var bundle_minimun = Number($bundle.attr("data-bundle-minimun"));
            var bundle_qty = Bundle.Utils.calculateBundleQuantity($bundle);
            var is_box_included = Bundle.Constraints.isBoxIncluded($bundle, Number(item.attr('data-qty')) + 1, item.attr("data-category"));
            var box_optional = productsJSON.box_optional;
            var current_bundle_quantities = Bundle.Utils.calculateBundleQuantityPerCategory($bundle);

            // For the 2 Pack Recipe Set, validate that only 1 500ml bottle is selected
            if(Bundle.Constraints.isBundleName('2 Pack Recipe Set', productsJSON.title)) {
                switch(item.data('category')) {
                    case 'extra-virgin-olive-oil':
                        if (current_bundle_quantities['infused-olive-oil'] > 0)
                            return;
                    case 'infused-olive-oil':
                        if (current_bundle_quantities['extra-virgin-olive-oil'] > 0)
                            return;
                }
            // For the Tea Towel Box, validate that only 1 500ml bottle is selected
            } else if(Bundle.Constraints.isBundleName('Tea Towel Box', productsJSON.title) && item.data('category') !== 'dish-towel') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 1) {
                    return;
                }
            } else if(Bundle.Constraints.isBundleName('Keepsake Gourmet Bundle', productsJSON.title) && item.data('category') !== 'dipping-spice' && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'];
                if (totalItems > 1) {
                    return;
                }
            } else if(Bundle.Constraints.isBundleName('Custom Tuscan Bundle', productsJSON.title) && item.data('category') !== 'dipping-spice' && item.data('category') !== 'pour-spout' && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 2) {
                    return;
                }
            } else if (Bundle.Constraints.isBundleName('3 Bottle Bundle 500ml', productsJSON.title)  && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 2) {
                    return;
                }
            } else if (Bundle.Constraints.isBundleName('3 Bottle Bundle 250ml', productsJSON.title)  && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 2) {
                    return;
                }
            } else if (Bundle.Constraints.isBundleName('4 Bottle Bundle 500ml', productsJSON.title)  && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 3) {
                    return;
                }
            } else if (Bundle.Constraints.isBundleName('4 Bottle Bundle 250ml', productsJSON.title)  && item.data('category') !== 'box') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['infused-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 3) {
                    return;
                }
            } else if (Bundle.Constraints.isBundleName('Custom Milan Bundle', productsJSON.title)  && item.data('category') !== 'box' && item.data('category') !== 'pour-spout' && item.data('category') !== 'dipping-spice') {
                let totalItems = current_bundle_quantities['extra-virgin-olive-oil'] + current_bundle_quantities['balsamic-vinegar'];
                if (totalItems > 1) {
                    return;
                }
            }
            // console.log('same name', Bundle.Constraints.isBundleName("2 Pack Recipe Set"))

            // console.log('bundle_minimun', bundle_minimun)
            // console.log('click');
            var current_max_qty = 0;
            // if (!$(this).data('category').includes('box') && bundle_qty < bundle_minimun || box_added == true) {
            if ( (bundle_qty <= bundle_minimun) && (is_box_included || box_optional) ) {
                // console.log('not box and can add')
                if ($(this).data('category') !== "") {
                    // console.log('has category');
                    $('.js-qty__num[data-category="' + $(this).data('category') + '"]').each(function() {
                        current_max_qty = current_max_qty + parseFloat($(this).val());
                        // console.log('current_max_qty', current_max_qty, productsJSON[$(this).data('category')].max);
                    });
                    if (productsJSON[$(this).data('category')].max) {
                        // console.log('has max')
                        if (current_max_qty < productsJSON[$(this).data('category')].max) {
                            // console.log('current_max < category.max')
                            Bundle.Utils.updateBundleQuantity(item, 1, $(document).find('.plus[data-variant-id="' + $(this).data("variant-id") + '"]'));
                        }
                    } else {
                        // console.log('not max')
                    }
                } else {
                    Bundle.Utils.updateBundleQuantity(item, 1, $(document).find('.plus[data-variant-id="' + $(this).data("variant-id") + '"]'));
                }
            }
            // else if ($(this).data('category').includes('box')) {
            //     all_box_added = all_box_added + 1;
            //     // console.log('is box and can add')
            //     box_added = true;
            //     Bundle.Utils.updateBundleQuantity(item, 1, $(document).find('.plus[data-variant-id="' + $(this).data("variant-id") + '"]'));
            // }
            // else {
            //     console.log('last')
            //     Bundle.Utils.updateBundleQuantity(item, 1, $(document).find('.plus[data-variant-id="' + $(this).data("variant-id") + '"]'));
            // }
        });

        // Registers the page's Add to Cart button
        $("body").on("click", "#bundle-add-to-cart", function(event) {
            event.preventDefault();
            Bundle.Cart.processAddToCart(productsJSON);
            return false;
        });

        $("body").on("click", ".js-remove", function(event) {
            event.preventDefault();
            var item = $(document).find('.bundle-item[data-variant-id="' + $(this).data("variant-id") + '"]');
            Bundle.Utils.updateBundleQuantity(item, -1, $(document).find('.minus[data-variant-id="' + $(this).data("variant-id") + '"]'));
            $(this).closest(".product-added-" + $(this).data("variant-id")).remove();
        });

        // Registers function to handle pricing changes when the
        // user changes the purchase type
        $("body").on("change", '#rc_radio_options input[name="purchase_type"]', function() {
            Bundle.Utils.updatePrice();
        });

        // Bit of a hack. Formats the purchase type options so they do
        // not show the semi-colon that is normally used when displaying
        // price on each purchase type option
        $(".rc_label").each(function() {
            var html_string = $(this).html();
            var new_string = html_string.replace(":", "");
            $(this).html(new_string);
        });
    },
};

// Call the init() function to register click handlers
Bundle.init();
$(document).ready(function() { 
    if($('.hide-box').length > 0) {
        $('.grid__item--box .btn-qty').click()
    }
    $('.hide-box .product-bundle-added-remove--box').remove();
})